import React from 'react';

/**
 * Local error boundary used around each admin tab body. Prevents a single
 * broken tab from white-screening the entire dashboard. Shows the actual
 * error so a fix is one refresh away.
 */
class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[admin-tab-crash]', this.props.tabId, error, info?.componentStack);
  }

  handleReset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div
        role="alert"
        data-testid="admin-tab-error"
        className="bg-red-900/25 border border-red-500/50 rounded-lg p-5 text-sm space-y-3"
      >
        <p className="text-red-300 font-black uppercase tracking-widest text-xs">
          This tab crashed
        </p>
        <p className="text-red-200 font-mono text-xs whitespace-pre-wrap break-words">
          {msg}
        </p>
        <p className="text-zinc-400 text-xs">
          The rest of the admin is still fine. Try reloading the page or switching tabs.
        </p>
        <button
          type="button"
          onClick={this.handleReset}
          className="bg-red-600 hover:bg-red-500 text-white font-black uppercase tracking-widest text-xs px-3 py-1.5 rounded"
        >
          Retry
        </button>
      </div>
    );
  }
}

export default AdminErrorBoundary;
